import apiWrapper from '../apiWrapprer'

const endpoints = {
  getFilter: '/frontend/webMethods/Statistics.asmx/GetFilter'
}

export const getFilter = (idList, guid, idFilter) => {
  const url = endpoints.getFilter
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList,
      guid,
      idFilter
    })
  }).then(extractData)
}

const extractData = ({ data }) => JSON.parse(data.d)

export const isFrontendError = (result) => {
  return (result.$types && Object.keys(result.$types)[0].split(',').map(k => k.trim()).includes('mailUp.lib.FrontendException')) ||
  (result.$type && (result.$type.match(/mailUp\.lib\.FrontendException/) !== null))
}
